/* =====================================================================
   custom.js — comportamentos da loja (DMSam) sobre o Broadcast 6.2.0
   1) Ponto no ícone do saco quando há artigos no carrinho
   2) Modal da tabela de tamanhos: título do produto, filtro das linhas
      pelos tamanhos existentes e fit guide
   3) Barra de escalões de desconto no cart drawer (quantidade real)
   3b) Esqueleto de carregamento na gaveta + total no botão de checkout
   ===================================================================== */
(function () {
  'use strict';

  /* ---------- 1) Ponto no saco ---------- */
  function setBagDot(count) {
    document.querySelectorAll('.icon-bag').forEach(function (svg) {
      svg.classList.toggle('has-items', count > 0);
    });
  }
  var dmCartUrgencyKey = 'dmCartUrgencyEnd:' + window.location.host;
  var dmCartUrgencyInterval = null;
  var dmCartUrgencyMemoryEnd = 0;

  function readDmCartUrgencyEnd() {
    try {
      return parseInt(window.sessionStorage.getItem(dmCartUrgencyKey), 10) || dmCartUrgencyMemoryEnd;
    } catch (e) {
      return dmCartUrgencyMemoryEnd;
    }
  }

  function writeDmCartUrgencyEnd(value) {
    dmCartUrgencyMemoryEnd = value;
    try { window.sessionStorage.setItem(dmCartUrgencyKey, value); } catch (e) {}
  }

  function clearDmCartUrgencyEnd() {
    dmCartUrgencyMemoryEnd = 0;
    try { window.sessionStorage.removeItem(dmCartUrgencyKey); } catch (e) {}
  }

  function stopDmCartUrgency() {
    if (dmCartUrgencyInterval) {
      clearInterval(dmCartUrgencyInterval);
      dmCartUrgencyInterval = null;
    }
  }

  function renderDmCartUrgency() {
    var bars = document.querySelectorAll('#cart-drawer [data-dm-cart-urgency]');
    // The drawer can briefly replace its markup after cart updates. Keep the timer running.
    if (!bars.length) return;

    var end = readDmCartUrgencyEnd();
    if (!end) return;
    var left = Math.ceil((end - Date.now()) / 1000);
    if (left <= 0) {
      var duration = parseInt(bars[0].getAttribute('data-duration'), 10) || 600;
      end = Date.now() + duration * 1000;
      writeDmCartUrgencyEnd(end);
      left = duration;
    }

    var minutes = Math.floor(left / 60);
    var seconds = left % 60;
    var value = (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
    bars.forEach(function (bar) {
      var output = bar.querySelector('[data-dm-cart-urgency-time]');
      if (output) output.textContent = value;
    });
  }

  function syncDmCartUrgency(count) {
    var bars = document.querySelectorAll('#cart-drawer [data-dm-cart-urgency]');
    if (count > 0) {
      bars.forEach(function (bar) { bar.hidden = false; });
      var duration = bars.length ? parseInt(bars[0].getAttribute('data-duration'), 10) || 600 : 600;
      var end = readDmCartUrgencyEnd();
      if (!end || isNaN(end) || end <= Date.now()) {
        end = Date.now() + duration * 1000;
        writeDmCartUrgencyEnd(end);
      }
      renderDmCartUrgency();
      if (!dmCartUrgencyInterval) {
        dmCartUrgencyInterval = setInterval(renderDmCartUrgency, 1000);
      }
    } else if (count === 0) {
      bars.forEach(function (bar) { bar.hidden = true; });
      clearDmCartUrgencyEnd();
      stopDmCartUrgency();
    }
  }

  function refreshCartCount() {
    fetch((window.theme && theme.routes && theme.routes.cart_url ? theme.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setBagDot(c.item_count || 0); window.dmCart = c; syncDmCartUrgency(c.item_count || 0); renderTierBars(c); })
      .catch(function () {});
  }
  document.addEventListener('theme:cart:change', function (e) {
    if (e.detail && typeof e.detail.cartCount !== 'undefined') setBagDot(e.detail.cartCount);
    refreshCartCount();
    setTimeout(syncCheckoutTotal, 60);
  });
  /* Esqueleto na gaveta enquanto um artigo é adicionado (Definições do tema → DM · Cart) */
  var dmSkeletonTimer = null;
  function dmSkeleton(on) {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || !drawer.querySelector('.dm-skeleton')) return;
    clearTimeout(dmSkeletonTimer);
    if (on) {
      drawer.classList.add('dm-loading');
      dmSkeletonTimer = setTimeout(function () { drawer.classList.remove('dm-loading'); }, 4000);
    } else {
      drawer.classList.remove('dm-loading');
    }
  }
  /* Total do carrinho dentro do botão "Checkout • $…" (gaveta e página) */
  function syncCheckoutTotal() {
    document.querySelectorAll('[data-cart-price-holder]').forEach(function (holder) {
      var src = holder.querySelector('[data-cart-total]');
      if (!src) return;
      var txt = (src.textContent || '').trim();
      if (!txt) return;
      var scope = holder.closest('#cart-drawer, [data-cart-page]') || document;
      scope.querySelectorAll('[data-dm-checkout-total]').forEach(function (el) { el.textContent = txt; });
    });
  }
  function watchCheckoutTotal() {
    document.querySelectorAll('[data-cart-price-holder]').forEach(function (holder) {
      if (holder.__dmWatched) return;
      holder.__dmWatched = true;
      new MutationObserver(function () { syncCheckoutTotal(); }).observe(holder, { childList: true, subtree: true, characterData: true });
    });
    syncCheckoutTotal();
  }
  (function hookCartRequests() {
    if (window.__dmCartHook) return;
    window.__dmCartHook = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var a = arguments[0];
      var url = typeof a === 'string' ? a : (a && a.url) || '';
      var p = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        if (/\/cart\/add/.test(url)) dmSkeleton(true);
        p.then(function () { setTimeout(refreshCartCount, 250); setTimeout(function () { dmSkeleton(false); }, 350); }).catch(function () { dmSkeleton(false); });
      }
      return p;
    };
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__dmUrl = u; return origOpen.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var x = this;
      if (/\/cart\/(add|change|update|clear)/.test(x.__dmUrl || '')) {
        if (/\/cart\/add/.test(x.__dmUrl || '')) dmSkeleton(true);
        x.addEventListener('loadend', function () { setTimeout(refreshCartCount, 250); setTimeout(function () { dmSkeleton(false); }, 350); });
      }
      return origSend.apply(this, arguments);
    };
  })();

  /* ---------- 2) Modal da tabela de tamanhos ---------- */
  function normSize(t) {
    var s = (t || '').toString().toLowerCase();
    s = s.replace(/[()]/g, ' ').replace(/\s+/g, ' ').trim();
    s = s.replace(/^(us|eu|uk|eur|size|talla|taille|maat|tamanho)\s*[:\-]?\s*/, '');
    s = s.replace(/\s*(us|eu|uk|eur)$/, '');
    s = s.replace(/\s+/g, '').replace(/,/g, '.').replace(/\.0$/, '');
    return s;
  }
  function availableSizes(productEl) {
    var sizes = [];
    productEl.querySelectorAll('.selector-wrapper--size input[type="radio"]').forEach(function (i) { sizes.push(normSize(i.value)); });
    return sizes;
  }
  function filterTableRows(modal, sizes) {
    if (!sizes.length) return;
    modal.querySelectorAll('table').forEach(function (table) {
      var ths = table.querySelectorAll('thead th');
      var idx = [];
      ths.forEach(function (th, i) {
        var h = (th.textContent || '').toLowerCase();
        if (h.indexOf('size') > -1 || h.indexOf('talla') > -1 || h.indexOf('taille') > -1 || h.indexOf('tamanho') > -1 || h.indexOf('größe') > -1) idx.push(i);
      });
      if (!idx.length) idx = [0];
      var rows = table.querySelectorAll('tbody tr');
      var kept = 0;
      rows.forEach(function (tr) {
        var cells = tr.querySelectorAll('td');
        var match = false;
        idx.forEach(function (i) { if (cells[i] && sizes.indexOf(normSize(cells[i].textContent)) > -1) match = true; });
        tr.classList.toggle('dm-size-hidden', !match);
        if (match) kept++;
      });
      if (!kept) rows.forEach(function (tr) { tr.classList.remove('dm-size-hidden'); });
    });
  }
  function renderFitGuide(modal) {
    modal.querySelectorAll('[data-fit-guide]').forEach(function (el) {
      if (el.dataset.dmRendered) return;
      el.dataset.dmRendered = '1';
      var active = parseInt(el.getAttribute('data-fit-guide'), 10) || 3;
      var wrap = document.createElement('div');
      wrap.className = 'dm-fit-guide';
      var segs = '';
      for (var i = 1; i <= 5; i++) segs += '<span class="dm-fit-guide__segment' + (i === active ? ' is-active' : '') + '"></span>';
      wrap.innerHTML =
        '<p class="dm-fit-guide__heading">' + (el.dataset.heading || 'Fit') + '</p>' +
        (el.dataset.text ? '<p class="dm-fit-guide__text">' + el.dataset.text + '</p>' : '') +
        '<div class="dm-fit-guide__line">' + segs + '</div>' +
        '<div class="dm-fit-guide__labels"><span>' + (el.dataset.left || 'Runs small') + '</span><span>' + (el.dataset.middle || 'True to size') + '</span><span>' + (el.dataset.right || 'Runs large') + '</span></div>';
      el.appendChild(wrap);
    });
  }
  function prepareSizeModals() {
    document.querySelectorAll('product-component, [data-section-type="product"]').forEach(function (productEl) {
      var titleEl = productEl.querySelector('.product__title');
      var title = titleEl ? titleEl.textContent.trim() : '';
      productEl.querySelectorAll('popup-component .product-modal').forEach(function (modal) {
        if (!modal.dataset.dmPrepared) {
          modal.dataset.dmPrepared = '1';
          var content = modal.querySelector('.product-modal__content');
          if (content && title) {
            var header = document.createElement('div');
            header.className = 'dm-size-modal-header';
            header.innerHTML = '<p class="dm-size-modal-title"></p><p class="dm-size-modal-subtitle">Size Chart</p>';
            header.querySelector('.dm-size-modal-title').textContent = title;
            var closeBtn = content.querySelector('.product-modal__close');
            if (closeBtn && closeBtn.nextSibling) content.insertBefore(header, closeBtn.nextSibling); else content.prepend(header);
          }
        }
        filterTableRows(modal, availableSizes(productEl));
        renderFitGuide(modal);
      });
    });
  }

  /* ---------- 3) Barra de escalões no carrinho ---------- */
  function parseTiers(str) {
    return (str || '').split(',').map(function (p) {
      var kv = p.split(':');
      return { qty: parseInt(kv[0], 10), pct: parseInt(kv[1], 10) };
    }).filter(function (t) { return t.qty > 0 && t.pct > 0; }).sort(function (a, b) { return a.qty - b.qty; });
  }
  function renderTierBars(cart) {
    var count = cart ? (cart.item_count || 0) : 0;
    document.querySelectorAll('[data-dm-tier-bar]').forEach(function (bar) {
      var tiers = parseTiers(bar.getAttribute('data-tiers'));
      if (!tiers.length) { bar.style.display = 'none'; return; }
      var max = tiers[tiers.length - 1];
      var reached = null, next = null;
      tiers.forEach(function (t) { if (count >= t.qty) reached = t; else if (!next) next = t; });
      var text;
      if (!next) {
        text = 'You unlocked the maximum <strong>extra ' + max.pct + '% off</strong>.';
      } else {
        var missing = next.qty - count;
        text = 'Add <strong>' + missing + ' more item' + (missing > 1 ? 's' : '') + '</strong> to get <strong>extra ' + next.pct + '% off</strong>' + (reached ? ' (now: extra ' + reached.pct + '% off)' : '') + '.';
      }
      var pctFill = Math.min(100, Math.round((count / max.qty) * 100));
      bar.querySelector('.dm-tier-bar__text').innerHTML = text;
      bar.querySelector('.dm-tier-bar__fill').style.width = pctFill + '%';
      bar.querySelectorAll('.dm-tier-bar__steps span').forEach(function (s) {
        s.classList.toggle('is-reached', count >= parseInt(s.getAttribute('data-qty'), 10));
      });
      bar.style.display = '';
    });
  }

  function init() {
    refreshCartCount();
    prepareSizeModals();
    watchCheckoutTotal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 50); });
  document.addEventListener('variant:changed', function () { setTimeout(prepareSizeModals, 50); });
  document.addEventListener('theme:variant:change', function () { setTimeout(prepareSizeModals, 50); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-popup-open]')) setTimeout(prepareSizeModals, 30);
  }, true);
})();

/* ---------- 4) Data estimada de entrega (dias úteis, a partir das Definições do tema) ---------- */
(function () {
  'use strict';
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }
  function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  function render() {
    document.querySelectorAll('[data-dm-delivery]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min-days'), 10);
      var max = parseInt(el.getAttribute('data-max-days'), 10);
      if (isNaN(min) || isNaN(max)) return;
      var today = new Date();
      var cal = el.hasAttribute('data-calendar');
      var a = cal ? new Date(today.getTime() + min * 86400000) : addBusinessDays(today, min);
      var b = cal ? new Date(today.getTime() + max * 86400000) : addBusinessDays(today, max);
      var range = el.querySelector('[data-dm-delivery-range]');
      if (range) range.textContent = (min === max) ? b.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) : fmt(a) + ' – ' + fmt(b);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render); else render();
  document.addEventListener('shopify:section:load', render);
})();

